import { useContext, useEffect, useState } from 'react';
import "./Distinctiveness.scss";
import DynamicDownloadBtnSection from '../../components/DynamicDownloadBtnSection/DynamicDownloadBtnSection';
import Lines from '../../components/Lines';
import { AppContext } from '../../context/AppContext';
import axios from 'axios';
import { toast } from 'react-toastify';

const Distinctiveness = () => {

    const { backendUrl } = useContext(AppContext);
    const [allDistinctivenessReports, setAllDistinctivenessReports] = useState([]);
     let errorShown = false;

        async function fetchAllDistinctivenessReports() {
        try {
            const { data } = await axios.get(`${backendUrl}/api/auth/getAllDistinctiveness`);
            if (data.success) {
                setAllDistinctivenessReports(data || []);
            } 
             errorShown = false;  
           
        } catch (error) {
            if (errorShown) return;
            errorShown = true;
           if (error.response && error.response.status === 503) {
                           toast.error("⚠️ The service is currently under maintenance. Please try again later.");
                       }
                       else if (!navigator.onLine) {
                           toast.error("🚫 No internet connection. Please check your network.");
                       }
           
                       else if (error.request && !error.response) {
                           toast.error("⚠️ Network issue or server is unreachable. Try again later.")
                       }
                       else 
                       {
                           console.error("Unexpected error:", error);
                           toast.error("Something went wrong.");
                       }
        }
    }

    useEffect(() => {
        fetchAllDistinctivenessReports();
    }, []);

    const content = allDistinctivenessReports?.reports
        ?.filter(item => item.isActive)
        .map(item => ({
            filename: item.filename,
            data: item.data,
            contentType: item.contentType,
        })) || [];

    return (
        <section className="distinctivenessMainContainer">
            <header className="distinctivenessHeader">
                <h2>Distinctiveness</h2>
                <span className="lines-parent">
                    <Lines count={25} color="#116C4A" fontSize={2.3} spacing={0.1} thickness={700} />
                </span>
            </header>
            <DynamicDownloadBtnSection
                yearFontSize={1.2}
                items={content}
            />
        </section>
    )
}

export default Distinctiveness
